export const machineTypes = <T>(): T => ({}) as T
